/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataUserCouponHistoryRespVo } from './PageDataUserCouponHistoryRespVo';
import {
    PageDataUserCouponHistoryRespVoFromJSON,
    PageDataUserCouponHistoryRespVoFromJSONTyped,
    PageDataUserCouponHistoryRespVoToJSON,
    PageDataUserCouponHistoryRespVoToJSONTyped,
} from './PageDataUserCouponHistoryRespVo';

/**
 * 
 * @export
 * @interface ResponsePageDataUserCouponHistoryRespVo
 */
export interface ResponsePageDataUserCouponHistoryRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataUserCouponHistoryRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataUserCouponHistoryRespVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataUserCouponHistoryRespVo}
     * @memberof ResponsePageDataUserCouponHistoryRespVo
     */
    data?: PageDataUserCouponHistoryRespVo;
}

/**
 * Check if a given object implements the ResponsePageDataUserCouponHistoryRespVo interface.
 */
export function instanceOfResponsePageDataUserCouponHistoryRespVo(value: object): value is ResponsePageDataUserCouponHistoryRespVo {
    return true;
}

export function ResponsePageDataUserCouponHistoryRespVoFromJSON(json: any): ResponsePageDataUserCouponHistoryRespVo {
    return ResponsePageDataUserCouponHistoryRespVoFromJSONTyped(json, false);
}

export function ResponsePageDataUserCouponHistoryRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataUserCouponHistoryRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataUserCouponHistoryRespVoFromJSON(json['data']),
    };
}

export function ResponsePageDataUserCouponHistoryRespVoToJSON(json: any): ResponsePageDataUserCouponHistoryRespVo {
    return ResponsePageDataUserCouponHistoryRespVoToJSONTyped(json, false);
}

export function ResponsePageDataUserCouponHistoryRespVoToJSONTyped(value?: ResponsePageDataUserCouponHistoryRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataUserCouponHistoryRespVoToJSON(value['data']),
    };
}

